import { useMantineTheme } from '@mantine/core'
import { getTextColor } from 'config/themeOverride/getColor'

export default function useSecondaryTextColor() {
  const theme = useMantineTheme()
  return getTextColor('gray.7', theme)
}
